export const REQUEST_TOKEN = "T_REQUEST";
export const RESPONSE_TOKEN = "T_RESPONSE";
export const NODE_LOGGER_SERVICE_TOKEN = "T_NODE_LOGGER_SERVICE";

// TODO: once `@obg/node.global` has been released to prod as is mature enough
// use `Logger` interface instead of duplicating the contract
export interface NodeLoggerService {
	log(level: any, message: string, data: Record<string, any>, request: any, brandId?: string): void;
}
